import { LoggedUserService } from './loggeduser.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  constructor(public LoggedUser: LoggedUserService, public router: Router) { }

  canActivate(): boolean {
    if (!this.LoggedUser.isLoggedIn()) {
      this.router.navigate(['/auth']);
      return false;
    }
    return true;
  }

}
